import { render } from "./IncomeFilterPopup.vue?vue&type=template&id=ff5a71b0&scoped=true"
import script from "./IncomeFilterPopup.vue?vue&type=script&lang=js"
export * from "./IncomeFilterPopup.vue?vue&type=script&lang=js"

import "./IncomeFilterPopup.vue?vue&type=style&index=0&id=ff5a71b0&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff5a71b0"]])

export default __exports__